import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'cj_cookie_consent';
const GA_ID = 'G-ED7FRH7F5H';

function updateConsent(granted: boolean) {
  const g = (window as any).gtag;
  if (typeof g === 'function') {
    g('consent', 'update', {
      analytics_storage: granted ? 'granted' : 'denied',
      ad_storage: granted ? 'granted' : 'denied',
      ad_user_data: granted ? 'granted' : 'denied',
      ad_personalization: granted ? 'granted' : 'denied',
    });
  }
  // Hard opt-out for GA4 if declined
  (window as any)[`ga-disable-${GA_ID}`] = !granted;
}

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let choice: string | null = null;
    try {
      choice = localStorage.getItem(STORAGE_KEY);
    } catch {
      /* storage blocked */
    }
    if (choice === 'granted') {
      updateConsent(true);
    } else if (choice === 'denied') {
      updateConsent(false);
    } else {
      setVisible(true);
    }
  }, []);

  const choose = (granted: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, granted ? 'granted' : 'denied');
    } catch {
      /* ignore */
    }
    updateConsent(granted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-3 sm:p-4">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl border border-gray-200 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3">
        <p className="text-sm text-gray-600 flex-1">
          We use cookies to analyze traffic and improve CarsJudge AI. See our{' '}
          <a href="/privacy" className="text-brand underline">Privacy Policy</a>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            onClick={() => choose(false)}
            className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 text-sm font-medium hover:bg-gray-50 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => choose(true)}
            className="px-4 py-2 rounded-xl bg-brand text-white text-sm font-semibold hover:bg-brand transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
